import { wrap as withStyle } from 'utils/styles'

// TODO: the 100% solution does not completely fix the issue with the action buttons not showing in the output editor.
export default withStyle(
  () => `
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    height: 100%; 
  `
)
